// crawler-options.tsx
import { Stack, Typography } from '@mui/material';
import PaiCheckbox from 'features/ui/base-components/pai-checkbox';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface CrawlerOptionProps {
  crawlerOptions?: {
    includeReactions?: boolean;
    includeComments?: boolean;
    includeAuthor?: boolean;
    includedProfileDegrees?: number[];
  };
  handlePeopleTypeChange: (type: 'includeReactions' | 'includeComments' | 'includeAuthor') => (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleProfileDegreeChange: (value: 1 | 2 | 3) => (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CrawlerOption: React.FC<CrawlerOptionProps> = ({
  // Provide a default empty object so destructuring won't fail
  crawlerOptions = {},
  handlePeopleTypeChange,
  handleProfileDegreeChange,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  // Destructure with defaults for each field
  const { includeReactions = true, includeComments = true, includeAuthor = true, includedProfileDegrees = [1, 2, 3] } = crawlerOptions;

  return (
    <Stack direction="row" gap={6}>
      <div>
        <Typography className={classes.label}>{t('includedPersonTypes')}</Typography>
        <Stack>
          <PaiCheckbox label={t('reactions')} checked={includeReactions} onChange={handlePeopleTypeChange('includeReactions')} />
          <PaiCheckbox label={t('comments')} checked={includeComments} onChange={handlePeopleTypeChange('includeComments')} />
          <PaiCheckbox label={t('authors')} checked={includeAuthor} onChange={handlePeopleTypeChange('includeAuthor')} />
        </Stack>
      </div>
      <div>
        <Typography className={classes.label}>{t('includedProfileDegrees')}</Typography>
        <Stack>
          <PaiCheckbox label={'1.'} checked={includedProfileDegrees.includes(1)} onChange={handleProfileDegreeChange(1)} />
          <PaiCheckbox label={'2.'} checked={includedProfileDegrees.includes(2)} onChange={handleProfileDegreeChange(2)} />
          <PaiCheckbox label={'3+'} checked={includedProfileDegrees.includes(3)} onChange={handleProfileDegreeChange(3)} />
        </Stack>
      </div>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  divider: {
    marginLeft: '48px',
    marginTop: 'calc(19.5px + 8px)',
    maxHeight: 'calc(100% - 19.5px - 8px)',
  },
  label: {
    marginBottom: '8px',
    fontSize: theme.typography.pxToRem(15),
    textDecoration: 'underline',
  },
}));

export default CrawlerOption;
